import jQuery from "jquery";
import Glide from "@glidejs/glide";

var current_gallery = false;

jQuery(document).keyup(function (e) {
    if (e.key === "Escape") {
        jQuery(".gallery-modal__wrapper").removeClass("active");
        if(current_gallery){
            current_gallery.destroy();
        }
    }
});


function openGallery(post_id, showGallery = false){
    //console.log(post_id);
    let selector = "#gallery-modal-" + post_id;
    let gallery = document.getElementById("gallery-modal-" + post_id);
    let gallery_modal = document.getElementById("gallery-modal-" + post_id + "__wrapper");

    if (gallery_modal) {
        gallery_modal.classList.add("active");
    }
    if (gallery && showGallery) {
        current_gallery = new Glide(selector, { type: "carousel" }).mount();
    }

}

document.addEventListener("DOMContentLoaded", function () {
    jQuery("#blog-list").on(
        "click",
        ".blog-post",
        function (e) {
            e.preventDefault();
            e.stopPropagation();
            //jQuery(this).parent().parent().toggleClass("active");
            openGallery(jQuery(this).data("postid"));
        }
    );

    jQuery("#blog-list").on("click", ".gallery-modal__close", function (e) {
        e.preventDefault();
        e.stopPropagation();
        jQuery(".gallery-modal__wrapper").removeClass("active");
        if (current_gallery) {
            current_gallery.destroy();
        }
    });



    jQuery(".gallery-modal__close").on("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        jQuery(".gallery-modal__wrapper").removeClass("active");
        if(current_gallery){
            current_gallery.destroy();
        }
    });

    jQuery(".images-item").on("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        openGallery(jQuery(this).data("postid"), true);
    });
});
